import { type RefObject, useEffect, useRef } from 'react';

import { afterFrames } from '@/lib/animate';

export function useScrollToBottomOnGrow(
  ref: RefObject<HTMLElement | null>,
  count: number,
  onBeforeScroll?: () => void
) {
  const prevCountRef = useRef(count);

  useEffect(() => {
    const prev = prevCountRef.current;
    prevCountRef.current = count;
    if (count <= prev) return;

    const el = ref.current;
    if (!el) return;

    onBeforeScroll?.();
    afterFrames(2, () =>
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
    );
  }, [ref, count, onBeforeScroll]);
}
